/**
* @description
* # name controller --> ambitsListController
* # As Controller --> ambitsList
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class ambitsListController {
	constructor($scope,ambitsServices,ngNotify,UserInfoConstant,$state,$filter,) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$state = $state;
		this.services = ambitsServices.services;
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.ordersList = [1,2,3]
		this.$scope.orderSelect = null
		

		$scope.UserInfoConstant = UserInfoConstant;
		$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.USER_ID = details.user.id;
				this.conceptId = details.user.conceptId
				this.init()
			}
		});

	}

	init(){
		this.services.getAmbits({ concept_id: this.conceptId}).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.ambits = []
				this.ambitsList = dataReturn.results;
				for (let i in this.ambitsList){
					this.ambits.push({
						title: this.ambitsList[i].ds_name,
						id_code: this.ambitsList[i].id_code,
						cod: "Código: " + this.ambitsList[i].id_code,
						badges: [
							{
								label: ( (this.ambitsList[i].is_active === true) ? this.$translate('ACTIVE') : this.$translate('INACTIVE')),
								bg: ( (this.ambitsList[i].is_active === true) ? "bg-success" : "bg-dark" ),
								icon: "mdi-check"
							}
						]
					})
				}
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	onClick(item){
		this.ambitId=item.id_code;
		this.ambitName=item.title;
		this.getDetailsFunction({ambit_id:this.ambitId});
		this.panelConfig = true
		this.buttonActions = false
	}

	getDetailsFunction(params){
		this.services.getAmbitDetails(params).$promise.then((dataReturn) => {
			if(dataReturn.results && Object.keys(dataReturn.results).length === 0){
				this.ngNotify.set('registro seleccionado no tiene registros','warn');

			}else{
				this.ambit = dataReturn.results
				this.$scope.orderSelect = this.ambit.is_order
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})

	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({ambit_id : this.ambitId});
		
	}

	saveEdit(){
		const params = {
			ambit_id: this.ambitId,
			name: this.ambitName,
			order: this.$scope.orderSelect,
			user_id: this.USER_ID
		}

		this.services.updateAmbits(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Ambito','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de ambito se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de ambito ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
ambitsListController.$inject=['$scope', 'ambitsServices','ngNotify','UserInfoConstant','$state','$filter']


// WEBPACK FOOTER //
// ./src/app/admin-panel/ambits/list/ambitsListController.js